import React, { useEffect, useState } from 'react';
import { Alert, Box, Snackbar, Stack, TextField, Typography, useMediaQuery, useTheme } from '@mui/material';
import { useLocation, useNavigate } from 'react-router-dom';
import AtplLinearBar from '../../components/ATPlab/AtplLinearBar';
import AtplFooter from '../../components/ATPlab/atpFooter/AtplFooter';
import { useClientApi } from '../../api/client';
import { CLIENT_TYPES } from '../../api/clientconfig';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import AtplPrimaryBtnNew from '../../components/ATPlab/AtplPrimaryBtn/AtplPrimaryBtnNew';
import { ATPLBackButton } from '../../components/ATPlab/AtplBackBtn';

const preSelectStyleForSlectedSinglevalue = {
	borderRadius: '10px',
	backgroundColor: "var(--atplGreyColor)",
}
const OptionButton = ({ option, onClick, optionSelectSingleValue, value }) => {
	const isSingleOptionSelected = optionSelectSingleValue === value;
			const theme = useTheme();
			const isLaptopUp = useMediaQuery(theme.breakpoints.up('md'));
	return <Box
		onClick={onClick}
		sx={{
			width: {
				xs: '280px',
				sm: '300px',
				md: '400px', // Increased width for laptop screens
				lg: '450px'  // Even wider for larger screens
			},
			height: {
				xs: '44px',
				md: '54px'
			},
			backgroundColor : "rgba(26, 26, 26, 0.08)" ,

			// border: '1px solid #b8b9bc',
			// boxShadow: "rgba(0, 0, 0, 0.15) 0px 1px",
			marginBottom : "8px",
			borderRadius: '10px',
			display: 'flex',
			justifyContent: 'center',
			alignItems: 'center',
			marginBottom: '10px',
			cursor: 'pointer',
			transition: 'all 0.2s ease-in-out',
			color: '#000',
			...(isSingleOptionSelected ? preSelectStyleForSlectedSinglevalue : {}),
			'&:hover': {
				// backgroundColor: '#fff1ed',
				// borderColor: '#ee5c36',
				transform: 'scale(1.02)',
				color: isLaptopUp ? 'white' : '#000',
				backgroundColor: isLaptopUp ? 'var(--atplGreyColor)' : 'rgba(26, 26, 26, 0.08)',
			}
		}}
	>
		<Typography
			sx={{
				fontSize: {
					xs: '14px',
					sm: '16px',
					md: '18px'  // Larger font for laptop screens
				},
				fontWeight: '400',
				// color: '#000'
			}}
		>
			{option}
		</Typography>
	</Box>
}

const StepContainer = ({ children, title, subTitle, btnTitle, onClickNext, sx = {} }) => (
	<Stack
		sx={{
			width: '100%',
			maxWidth: {
				xs: '300px',
				sm: '390px',
				md: '800px',  // Much wider for laptop screens
				lg: '1000px'  // Even wider for larger screens
			},
			display: 'flex',
			justifyContent: 'center',
			alignItems: 'center',
			textAlign: 'center',
			...sx
		}}
	>
		<Typography
			sx={{
				fontSize: {
					xs: '23px',
					sm: '23px',
					md: '23px'  // Larger font for laptop screens
				},
				fontWeight: '700',
				lineHeight: '27px',
				textAlign: 'center',
				mb: subTitle ? 2 : 4
			}}
		>
			{title}
		</Typography>
		{children}
		{btnTitle && (
			// <Box
			// 	onClick={onClickNext}
			// 	sx={{
			// 		width: {
			// 			xs: '175px',
			// 			sm: '175px',
			// 			md: '200px',  // Wider button for laptop screens
			// 			lg: '200px'
			// 		},
			// 		height: {
			// 			xs: '57px',
			// 			md: '60px'  // Taller button for laptop screens
			// 		},
			// 		backgroundColor: '#ee5c36',
			// 		borderRadius: '10px',
			// 		display: 'flex',
			// 		justifyContent: 'center',
			// 		alignItems: 'center',
			// 		cursor: 'pointer',
			// 		'&:hover': {
			// 			backgroundColor: '#d64f2f'
			// 		}
			// 	}}
			// >
			// 	<Typography
			// 		sx={{
			// 			fontSize: {
			// 				xs: '16px',
			// 				md: '18px'  // Larger font for laptop screens
			// 			},
			// 			color: '#fff'
			// 		}}
			// 	>
			// 		{btnTitle}
			// 	</Typography>
			// </Box>
			<AtplPrimaryBtnNew text={btnTitle} onClick={onClickNext} sx={{
				maxWidth: "342px",
				width : "100%",
				height: {
					xs: '57px',
					md: '60px'  // Taller button for laptop screens
				},
			}} />
		)}
	</Stack>
);

const AtplSymptomChecker = () => {
	const navigate = useNavigate();
	const location = useLocation();
	const clientApi = useClientApi(CLIENT_TYPES.ATP);
	const resultsToken = new URLSearchParams(location.search).get('result');
	const [symptomValidationError, setSymtomValidationError] = useState("")
	const [isExperiencingHealthSymptom, setIsExperiencingHealthSymptom] = useState(() => {
		const storedValue = localStorage.getItem('isExperiencingHealthSymptomAtpl');
		if (storedValue === null) {
			return "";  
		} else {
			return storedValue === 'true'; // returns true if value is 'true', false otherwise
		}
	});

	const [experiencedSymptomsDec, setExperiencedSymptomsDec] = useState(() => {
		const isStoreSymptomDescAtpl = localStorage.getItem('symptomDescAtpl');
		if (isStoreSymptomDescAtpl) {
			return isStoreSymptomDescAtpl;
		}
		return "";
	});

	const [currentStep, setCurrentStep] = useState(() => {
		const isStoreSymptomDescAtpl = localStorage.getItem('symptomDescAtpl');
		if (isStoreSymptomDescAtpl) {
			return 1
		}
		return 0;
	});
	// const [currentStep, setCurrentStep] = useState(() => {
	// 	// Check if the key 'symptomDescAtpl' exists in localStorage
	// 	const isStoreSymptomDescAtpl = localStorage.getItem('symptomDescAtpl');

	// 	// If the key exists and has a truthy value (not null or an empty string), return 0
	// 	if (isStoreSymptomDescAtpl) {
	// 	  return 0;
	// 	}

	// 	// If the key doesn't exist or is falsy (null, empty string), return 2
	// 	return 2;
	//   });
	const [isServerError, setIsServerError] = useState(false);
	const [isLoading, setIsLoading] = useState(false);

	useEffect(() => {
		localStorage.setItem('organization_id', '2');
		if (resultsToken) {
			localStorage.setItem('results_token', resultsToken);
		}
	}, [resultsToken]);

	const handleOptionSelect = (value) => {
		setIsExperiencingHealthSymptom(value);
		if (value) {
			setCurrentStep((prev) => prev + 1);
		} else {
			navigate('/atpl-health-profile');
			localStorage.removeItem('symptomDescAtpl');
			// handleEmptySymptoms();
		}
		localStorage.setItem('isExperiencingHealthSymptomAtpl', value);
	};

	useEffect(() => {
		if (isExperiencingHealthSymptom) {
			sessionStorage.setItem('symptom-checker-symptomsExist', isExperiencingHealthSymptom);
		} else {
			sessionStorage.removeItem('symptom-checker-symptomsExist');
		}
	}, [isExperiencingHealthSymptom]);

	
	const handleNextStep = async () => {
		if(experiencedSymptomsDec){
			setSymtomValidationError("")
			localStorage.setItem('symptomDescAtpl', experiencedSymptomsDec);
			navigate('/atpl-health-profile');
		}else{
			setSymtomValidationError("Please add symptom description")
		}
		
	};

	const renderStep1 = () => (
		<StepContainer
			title="Are you experiencing any health symptoms?"
			// sx={{
			// 	mt: {
			// 		xs: '50px',
			// 		sm: '150px',
			// 		md: '150px'
			// 	}
			// }}
		>
			<Stack
				sx={{
					width: '100%',
					display: 'flex',
					justifyContent: 'center',
					alignItems: 'center',
					mt: 2
				}}
			>
				{[
					{ label: "Yes", value: true },
					{ label: "No", value: false },
				].map((option, index) => (
					<OptionButton

						optionSelectSingleValue={isExperiencingHealthSymptom}  // Pass the current selected value
						value={option.value}  // Pass value to compare with userData
						key={index}
						option={option.label}
						onClick={() => handleOptionSelect(option.value)}
					/>
				))}
			</Stack>
		</StepContainer>
	);

	const onBackArrowClickHandler = () => {
		if (currentStep == 1) {
			setCurrentStep(0);
		} else if((currentStep == 0)){
			navigate('/atpl-pre-face-scan')
		}
	}


	const renderStep2 = () => (
		<StepContainer
			subTitle
			title="Can you tell us more?"
			btnTitle="Next"
			onClickNext={handleNextStep}
			// sx={{
			// 	mt: {
			// 		xs: '20px',
			// 		sm: '50px',
			// 		md: '50px'
			// 	}
			// }}
		>
			<Stack sx={{ mt: 1, width: '100%', alignItems: 'center' }}>
				<Typography
					sx={{
						fontSize: {
							xs: '14px',
							sm: '14px',
							md: '16px'
						},
						fontWeight: '400',
						lineHeight: '18px',
						textAlign: 'center'
					}}
				>
					In as much detail as you can,
					please tell us about the symptoms
					you've been experiencing.
				</Typography>

				<Box
					sx={{
						width: '100%',
						my: 2,
						px: {
							xs: 1,
							sm: 2,
							md: 2
						}
					}}
				>
					<TextField
						placeholder="I am not feeling well, I just don’t have energy. My sleep is interrupted, my mouth is dry. My body feels a bit inflamed, and I have trouble recovering after my workout."
						multiline
						minRows={2}
						value={experiencedSymptomsDec}
						onChange={(e) => setExperiencedSymptomsDec(e.target.value)}
						error={symptomValidationError}
						helperText={symptomValidationError}
						sx={{
							// Width: defined based on screen size
							width: {
							  xs: '300px',
							  sm: '400px',
							  md: '500px',
							  lg: '500px',  // keeping consistent width for large screens
							},
						  
							// OutlinedInput root styles
							'& .MuiOutlinedInput-root': {
							  borderRadius: '12px',
							  transition: 'all 0.2s ease-in-out',
							  background: '#F5F5F5',
							  height: {
								xs: '150px',
								sm: '225px',
								md: '225px',  // consistent height for sm and md breakpoints
							  },
						  
							  // fieldset styles
							  '& fieldset': {
								borderRadius: '10px',  // Make sure all fieldsets have this border radius
								border: '1px solid transparent',  // Remove default border visibility
							  },
						  
							  // Remove default border color on hover
							  '&:hover fieldset': {
								borderColor: 'transparent', // Hide hover border color
								borderWidth: '1px',
							  },
						  
							  // On focus, override default styling
							  '&.Mui-focused fieldset': {
								borderColor: 'var(--atplGreyColor)',
								borderWidth: '1px',
								borderRadius: '10px',
							  },
							},
						  
							// Input base styles
							'& .MuiInputBase-input': {
							  height: {
								xs: '120px !important',
								sm: '195px !important',
								md: '190px !important',
							  },
							  padding: {
								xs: '5px',
								sm: '16px',
								md: '16px',
							  },
							  fontSize: {
								xs: '14px',
								sm: '16px',
								md: '16px',
							  },
							  lineHeight: '1.5',
							  color: '#2c2c2c',
						  
							  // Placeholder styling
							  '&::placeholder': {
								color: 'rgba(0, 0, 0, 0.20)',
								fontSize : { xs : '14px',sm : "16px", lg : "18px"},
								fontWeight: 500,
								
								// opacity: 0.8,
							  },
							},
						  }}
					/>
					
				</Box>
			</Stack>
		</StepContainer>
	);

	const renderStep = () => {
		switch (currentStep) {
			case 0:
				return renderStep1();
			case 1:
				return renderStep2();
			default:
				return null;
		}
	};

	return (
		<Box
		className="atpl-default-css-config" // Ensures ATPL default CSS is applied
		sx={{
		  display: 'flex',
		  flexDirection: 'column',
		  minHeight: {
			xs: '88vh', // Adjust height for mobile devices
			sm: '98vh',
			md: '100vh',
			lg: '100vh',
		  }, // Full viewport height
		  bgcolor: 'white',
		  overflowX: 'hidden',
		}}
	  >

		  <>
			{/* Progress Bar Section */}
			<Box
			  sx={{
				px: { xs: 2, sm: 4, md: 30 },
				pt: { xs: "6px", sm: 2, md: 2 },
				mb: { xs: "2px", sm: 1, md: 1, lg: 2 },
			  }}
			>
			  <Stack textAlign="start">
				<ATPLBackButton
				  onClick={onBackArrowClickHandler}
				/>
			  </Stack>
			  <AtplLinearBar value={(currentStep + 1) * (100 / 20)} />
			</Box>
	  
			{/* Main Content Area */}
			<Box
			  component="main"
			  sx={{
				boxSizing: 'border-box',
				flex: 1, // Takes up remaining space
				display: 'flex',
				flexDirection: 'column',
				width: '100%',
				px: { xs: 1, sm: 4 },
				mb: { xs: '14px', sm: 3, md: 4, lg: 4 },
			  }}
			>
			  <Box
				sx={{
				  flex: 1,
				  display: 'flex',
				  flexDirection: 'column',
				  alignItems: 'center',
				  justifyContent: 'center',
				}}
			  >
				{renderStep()}
			  </Box>
			</Box>
	  
			{/* Footer */}
			<Box
			  component="footer"
			  sx={{
				width: '100%',
				pb: { xs: '0px', sm: 2, md: 1, lg: 2 },
				bgcolor: 'white',
			  }}
			>
			  <AtplFooter footerTitle="This health assessment is powered by" />
			</Box>
		  </>
	
	  </Box>
	);
};

export default AtplSymptomChecker;